import { initializeSite } from './common';

document.addEventListener('DOMContentLoaded', function() {
    // Initialize common functionality
    initializeSite();
    
    // Setup tabs in How It Works section (main page specific)
    setupTabs();
});

// Setup tabs in How It Works section
function setupTabs() {
    const tabBtns = document.querySelectorAll('.tab-btn');
    
    tabBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            // Remove active class from all buttons and tabs
            tabBtns.forEach(b => b.classList.remove('active'));
            document.querySelectorAll('.tab-content').forEach(tab => tab.classList.remove('active'));
            
            // Add active class to clicked button
            this.classList.add('active');
            
            // Show corresponding tab
            const tabId = this.getAttribute('data-tab') + '-tab';
            document.getElementById(tabId).classList.add('active');
            
            // Track tab switching for analytics
            if (window.gtag) {
                gtag('event', 'tab_switch', {
                    'event_category': 'engagement',
                    'event_label': this.getAttribute('data-tab')
                });
            }
        });
    });
}